import { TableData } from 'aw-grid'
import './3DDataGrid.scss'
import ReportingPdfDownload from '../DataSheetPdfDownload.component'
import { Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const D3DataGrid = (props: { loadingData: boolean, currentData: TableData, modelImg: string }) => {
    const { t } = useTranslation();
    return (
        <div className='p-2 rounded-1 d-flex flex-column text-center flex-fill'  style={{ backgroundColor: 'var(--background-secondary)', height: '100%', width: '100%', position: 'relative', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
            <span className="h2 mb-2">{t('Data')}</span>
            {!props.loadingData && <table className='mt-3 general3DData'>
                <tbody>
                    <tr>
                        <td className='text-white'>{t('NSerie')}</td>
                        <td>{props.currentData.item[1]}</td>
                    </tr>
                    <tr>
                        <td className='text-white'>{t('Model')}</td>
                        <td>{props.currentData.item[2]}</td>
                    </tr>
                    <tr>
                        <td className='text-white'>{t('MaterialCode')}</td>
                        <td>{props.currentData.item[3]}</td>
                    </tr>
                    <tr>
                        <td className='text-white'>{t('StartPrint')}</td>
                        <td>{props.currentData.item[4]}</td>
                    </tr>
                    <tr>
                        <td className='text-white'>{t('EndPrint')}</td>
                        <td>{`26/11/2025 20:38`}</td>
                    </tr>
                    <tr>
                        <td className='text-white'>{t('PrintingTime')}</td>
                        <td>{props.currentData.item[5]}</td>
                    </tr>
                    <tr>
                        <td className='text-white'>{t('NumOfPoints')}</td>
                        <td>{`14.847`}</td>
                    </tr>
                </tbody>
            </table>}
            {props.modelImg.length > 0 && !props.loadingData && <ReportingPdfDownload modelImgUrl={props.modelImg} />}
            {props.loadingData && <div className="text-center"><Spinner animation="border" variant="success" /></div>}
        </div>
    )

}

export default D3DataGrid